import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface GetNextPasswordValidationAttemptDatePararms {
  username: string;
}

// Just a date
export interface GetNextPasswordValidationAttemptDateResult extends IResult {
}

export class GetNextPasswordValidationAttemptDate extends Request<GetNextPasswordValidationAttemptDatePararms, GetNextPasswordValidationAttemptDateResult> {
  constructor(username: string) {
    super('getNextPasswordValidationAttemptDate', {username: username});
  }
}
